import React, { useEffect, useState } from "react";
/**
 * importes do slide
 */
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Slide from "@material-ui/core/Slide";
import { TransitionProps } from "@material-ui/core/transitions";

import ArrowBackIcon from '@material-ui/icons/ArrowBack';

import { render } from "react-dom";
import mappa from "../../assets/globe_dark.jpg";
import ReactGlobe from "react-globe";
/**
 * lista de teste
 */
//import markers from "./markers";
import markerRenderer from "./markerRenderer";

import "./styles.css";

import api from "../../server/api";
import markers from "./markers";

//"https://raw.githubusercontent.com/chrisrzhou/react-globe/master/textures/globe_dark.jpg",

type CardProps = {
  visible: string;
};

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & { children?: React.ReactElement<any, any> },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function Mapp({ visible }: CardProps) {
  const [data, setData] = useState([]);
  const [message, setMessage] = useState("");
  /**
   * Variaveis da caixa de comentário
   */

  const [open, setOpen] = React.useState(false);

  async function handleClickOpen(m: any) {
    await setMessage(m);
    setOpen(true);
  }

  const handleClose = () => {
    setOpen(false);
  };

  /**
   * interface criada para receber o objeto do axios
   */
  interface serverData {
    data: [];
  }

  useEffect(() => {
    /**
     * instancia do axios
     */
    // api.defaults.headers.post["Content-Type"] =
    //   "application/json;charset=utf-8";
    // api.defaults.headers.post["Access-Control-Allow-Origin"] = "*";
    api.get().then((e: serverData) => setData(e.data));
  }, [visible]);

  return (
    <div className="App" style={{ display: visible }}>
      {/* <div>
           {data.map((e: any)=>{
             console.log(e)
             if(e.messages){
               return <h3>{e.message}</h3>
             }
           })}
      </div> */}
      <div className="exit" onClick={()=> window.location.reload()}> 
       <ArrowBackIcon
       style={{color: "cyan", fontSize: 60}}
       fontSize="large"
       >
       </ArrowBackIcon>
      </div>

      <ReactGlobe
    
        globeOptions={{
          texture:
            "https://raw.githubusercontent.com/chrisrzhou/react-globe/master/textures/globe_dark.jpg",
        }}
        markers={data}
        onClickMarker={(e) => {
          //handleClickOpen(e.message);
          //console.log(e.coordinates);
        }}
        markerOptions={{
          renderer: markerRenderer,
          getTooltipContent: (marker) => {
            if (!marker.messages) {
              return marker.message;
            } else {
              let msn: any = [];
              marker.messages.map((i: any) => msn.push(i.message));
              return msn.join(' - ');
            }
          },
        }}
      />
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title">{"Message"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {message}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Return
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
